import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { AuthService } from './auth.service';
import 'rxjs/add/operator/do';
import { Router } from '@angular/router';
import { UserModel } from '../models/user.model';
import { CookieService } from 'ng2-cookies';

@Injectable()
export class MyHttpInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private router: Router, private cookieService: CookieService) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      setHeaders: {
        Authorization: this.authService.token
      }
    });

    const headers = {
      Authorization: this.authService.token
    };

    request = request.clone({
      setHeaders: headers,
      withCredentials: true
    });

    return next.handle(request).do(
      () => {},
      (err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 403) {
            this.logout();
            this.router.navigate(['/sign-in'], { queryParams: { sessionExpired: true } });
          }
        }
      }
    );
  }

  logout(): void {
    this.authService.userModel.next({} as UserModel);
    this.cookieService.delete('token');
    this.authService.token = '';
    this.router.navigate(['sign-in']);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/my-http-interceptor.ts